import React, { Fragment, useEffect, useState } from 'react'
import {
  Box,
  Flex,
  Button,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Spinner,
  useToast,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';
import { MdOutlineChevronRight } from "react-icons/md";
// import { HiPencil } from "react-icons/hi";
import AllFillters from './Layout/AllFillters';
import axios from 'axios';
import { Auth } from './Auth';
const AllNotification = ({ title, head, data, statusToggle, filterId, isLoading, title2 }) => {
  const [allChecked, setAllChecked] = useState([]);
  const [selectedStatus, setSelectedState] = useState([])
  const [updateSpinner, setUpdateSpinner] = useState(false)
 
  const toast = useToast()

  

  const handleAllChecked = (e) => {
    if (allChecked.length !== data?.length) {
      let arr = data?.map((x) => x.notificationId);
      let isAll = data?.map((d) => {
        return { status: true, id: `${d.id}`, automationTypeId: `${d.automationTypeId}`, automationId: `${d.automationId}`  }
      })
      setSelectedState(isAll)
      setAllChecked(arr);
    } else {
      setAllChecked([]);
      let isAll = data?.map((d) => {
        return {status: false, id: `${d.id}`, automationTypeId: `${d.automationTypeId}`, automationId: `${d.automationId}` }
      })
      setSelectedState(isAll)
    }
  };
  const handleAllChildrenClick = (e,i,item) => {
    if (allChecked.includes(i)) {
      setAllChecked((prev) => {
        let arr = prev.filter((x) => x !== i);
        return arr;
      });
      e.target.checked = false;
    } else {
      setAllChecked((prev) => {
        let arr = [...prev, i];
        return arr;
      });
      e.target.checked = true;
    }
  };

  useEffect(() => {
    const arr = data.map((d) => d.status === true && d.notificationId)
    setAllChecked(arr)
  },[data])

// API Call for bulk update
const saveHandler = () => {
  let data = JSON.stringify(selectedStatus);
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_NOTIFICATION_BASE_URL}/update-notifications-statuses`,
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': Auth()
    },
    data : data
  };
  console.log(JSON.parse(data).length > 0, '444444444')
  if(data.length > 2){
    setUpdateSpinner(true)
    axios.request(config)
    .then((response) => {
      setUpdateSpinner(false)
      toast({
        title: `Status updated successfully`,
        position: 'top',
        status: 'success',
        isClosable: true,
      })
      setSelectedState([])
    })
    .catch((error) => {
      console.log(error);
      setUpdateSpinner(false)
      toast({
        title: `Something went wrong please try again later`,
        position: 'top',
        status: 'error',
        isClosable: true,
      })
    });
  }else {
    toast({
      title: `Please first change status`,
      position: 'top',
      status: 'error',
      isClosable: true,
  })
}
  
}






  return (
    <Fragment>
    <AllFillters
             title={title}
             data={data}
             filters = {[{"Filter Notification":[{id: 'ALL', title: 'All Notifications'}, {id: 'ORDER_TICKET', title: 'Order'}, {id: 'TENURE_TICKET', title: 'Tenure'}, {id: 'CUSTOMER_VERIFICATION_TICKET', title: 'Customer Verification'},
             {id: 'RETURN_TICKET', title: 'Return'} , {id: 'SETTLEMENT_TICKET', title: 'Settlement'}, {id: 'DISPUTE_TICKET', title: 'Dispute'}
            ]}]}
            filterId={filterId}
            title2={title2}
            //  filters = {[{"Date": filterbyDate}, {"Profession": filterByProfession}]}
          />
   <Box maxW={'full'} my={4} position={'relative'} maxheight={'89vh'}>
      
        {/* Notification Table */}
             {updateSpinner && 
             <Flex justifyContent={'center'} position={'absolute'} top={{'sm': '200px', 'md': '200px', 'lg': '200px', 'xl': '200px', '2xl': '250px'}} right={{'sm': '480px', 'md': '480px', 'lg': '480px', 'xl': '480px', '2xl': '750px'}} zIndex={'99'} >
                <Spinner
                  thickness='6px'
                  speed='0.65s'
                  emptyColor='gray.200'
                  color='blue.500'
                  size='xl'
                  
                />
             </Flex>}
             <TableContainer sx={updateSpinner && {pointerEvents: 'none', opacity: '0.4'}} height={`${window.innerHeight - 170}px`} overflowY={'scroll'}>
                 <Table variant={'simple'} size={'xs'}>
                     <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                         <Tr bgColor={'#E2DFDF'}>
                             {/* {head.map((h, i) => (
                                 <Th fontSize={'xs'} py={3} key={i} _first={{paddingLeft: '20px'}} color={'#25282B'}>{h}</Th>
                             ))} */}
                             <Th fontSize={'xs'} py={3} paddingLeft={'20px'} color={'#25282B'}>{'Notification Name'}</Th>
                             <Th fontSize={'xs'} py={3}  color={'#25282B'}>{'Recipient'}</Th>
                             {/* Notification Toggle */}
                             <Th fontSize={'xs'} py={3}  color={'#25282B'}>
                              <Text as="span" mr={2}>
                              {'Manage Notifications'}
                              </Text>
                              <Switch
                                isIndeterminate={allChecked.length === data?.length && allChecked.length > 0}
                                isChecked={allChecked.some((x) => x !== false )}
                                onChange={(e) => {
                                  handleAllChecked(e);
                              }}
                              ></Switch> 
                              </Th>
                             {/* <Th fontSize={'xs'} py={3}  color={'#25282B'}>{'Action'}</Th> */}
                             {/* Save Notification Status */}
                             <Th w={'0px'}>
                                <Box mr={'20px'}>
                                  <Button
                                    colorScheme="twitter"
                                    size={"xs"}
                                    px={4}
                                    shadow={"md"}
                                    rounded={"sm"}
                                    onClick={saveHandler}
                                  >
                                    Save Changes
                                  </Button>
                                </Box>
                             </Th>
                         </Tr>
                     </Thead>
                     <Tbody>
                  
                     {(data.length > 0) ?
                     <>
                         {data?.map((d, i) => (
                             <Tr key={i} bgColor={'white'}>
                                 <Td fontSize={'xs'} py={3} pl={5}>{d.notificationName}</Td>
                                 <Td fontSize={'xs'} py={3}>{d.recipient}</Td>
                                 <Td fontSize={'xs'} py={3} >                
                                 <Switch
                                  id={`check_${d.notificationId}`}
                                  size="md"
                                  isChecked={allChecked.includes(d.notificationId) ? true : false}
                                  onChange={(e) => {
                                    handleAllChildrenClick(e,d.notificationId,d)
                                    setSelectedState((prev) => [...prev, { status: e.target.checked, id: d.id, automationTypeId: d.automationTypeId, automationId: d.automationId }])
                                  }}
                                  ></Switch>                                
                                 </Td>
                                 {/* <Td fontSize={'xs'} py={3}>
                                    <Flex >
                                    <Box bgColor={'#8BC34A'} p={'4px'} rounded={'xl'} mr={2}>
                                        <HiPencil color={'white'} />
                                    </Box>
                                    </Flex>
                                 </Td> */}
                                 
                                 <Td fontSize={'xs'}>
                                     <Flex justifyContent={'center'}>
                                         <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                                             <Link to={`/notification/details/${d.id}`} > <MdOutlineChevronRight /> </Link>
                                         </Box>
                                     </Flex>
                                 </Td>
                             </Tr>
                         ))}
                         </>
                         : 
                         <Tr>
                          <Td></Td>
                          <Td></Td>
                          <Td>
                          {isLoading.loading === true ?
                            <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor='gray.200'
                            color='blue.500'
                            size='xl'
                            mt={4}
                        
                          />
                          :
                          isLoading.error === true ? <Text fontWeight={'semibold'} color={'red.500'}>Oops we are facing some temporary issue with your request</Text> : <Text  fontWeight={'semibold'} color={'green.500'}>NO NOTIFICATION FOUND</Text>
                          } </Td>
                          <Td></Td>
                          <Td></Td>
                         </Tr>
                        }
                     </Tbody>
                 </Table>
             </TableContainer>  
         </Box>
 </Fragment>
  )
}

export default AllNotification